import { ReadinessElaTransferCtrl } from './readiness-ela-transfer.controller';

export const ReadinessElaStepTransferComponent = {
  controller: ReadinessElaTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./readiness-ela-transfer.html'),
};
